import React, { useState } from "react";
import {
	Alert,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControlLabel,
	Grid,
	IconButton,
	InputAdornment,
	Switch,
	TextField,
	Typography,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export const CredencialesUsuarioDialog = ({
	open,
	persona,
	credentialsEnabled,
	onCredentialsEnabledChange,
	credentialsMail,
	onCredentialsMailChange,
	credentialsPhone,
	onCredentialsPhoneChange,
	credentialsPassword,
	onCredentialsPasswordChange,
	credentialsPasswordConfirm,
	onCredentialsPasswordConfirmChange,
	credentialsDialogError,
	credentialsSaving,
	onClose,
	onSave,
	onSaveAndWhatsapp,
	hasCredencialesActivas,
	hasEmailConfigured,
	hasPasswordConfigured,
}) => {
	const [showPassword, setShowPassword] = useState(false);
	const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
	const nombrePersona =
		[persona?.apellidos, persona?.nombre].filter(Boolean).join(" ").trim() ||
		persona?.nombre_completo ||
		`Persona ${persona?.id}`;

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
			<DialogTitle>Credenciales del usuario</DialogTitle>
			<DialogContent>
				{persona && (
					<Grid container spacing={2} sx={{ pt: 0.5 }}>
						<Grid item size={{ xs: 12 }}>
							<Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
								{nombrePersona}
							</Typography>
							<Typography variant="body2" color="text.secondary">
								Estado actual: {hasCredencialesActivas(persona) ? "activo" : "inactivo"}
							</Typography>
						</Grid>

						<Grid item size={{ xs: 12 }}>
							<FormControlLabel
								control={
									<Switch
										checked={credentialsEnabled}
										onChange={(event) => onCredentialsEnabledChange(event.target.checked)}
									/>
								}
								label={credentialsEnabled ? "Credenciales activas" : "Credenciales inactivas"}
							/>
						</Grid>

						<Grid item size={{ xs: 12 }}>
							<TextField
								fullWidth
								type="email"
								label="Email"
								value={credentialsMail}
								onChange={(event) => onCredentialsMailChange(event.target.value)}
								helperText={
									hasEmailConfigured(persona)
										? "Se ha cargado el email actual. Puedes ajustarlo si lo necesitas."
										: "Se ha autogenerado con el formato nombre@planaett.com."
								}
							/>
						</Grid>

						<Grid item size={{ xs: 12 }}>
							<TextField
								fullWidth
								label="Telefono para WhatsApp"
								value={credentialsPhone}
								onChange={(event) => onCredentialsPhoneChange(event.target.value)}
								helperText="Si escribes 9 digitos, se asumira prefijo de Espana (+34)."
							/>
						</Grid>

						{credentialsEnabled && !hasEmailConfigured(persona) && (
							<Grid item size={{ xs: 12 }}>
								<Alert severity="info">
									Este usuario no tiene email. Se le asignara uno con formato nombre@planaett.com.
								</Alert>
							</Grid>
						)}

						{credentialsEnabled && !hasPasswordConfigured(persona) && (
							<Grid item size={{ xs: 12 }}>
								<Alert severity="info">
									Este usuario no tiene contrasena. Define una para poder activar sus credenciales.
								</Alert>
							</Grid>
						)}

						{credentialsEnabled &&
							hasPasswordConfigured(persona) &&
							hasEmailConfigured(persona) && (
							<Grid item size={{ xs: 12 }}>
								<Alert severity="success">
									El usuario ya tiene contrasena. Solo se cambiara si la editas o si la envias por WhatsApp.
								</Alert>
							</Grid>
						)}

						{!credentialsEnabled && (
							<Grid item size={{ xs: 12 }}>
								<Alert severity="warning">
									Si guardas, el usuario dejara de poder iniciar sesion aunque conserve su contrasena.
								</Alert>
							</Grid>
						)}

						{credentialsEnabled && (
							<>
								<Grid item size={{ xs: 12, md: 6 }}>
									<TextField
										fullWidth
										type={showPassword ? "text" : "password"}
										label="Contrasena"
										value={credentialsPassword}
										onChange={(event) => onCredentialsPasswordChange(event.target.value)}
										helperText="Por defecto se usa el NIF/NIE actual del usuario y puedes previsualizarlo con el icono del ojo."
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														edge="end"
														aria-label="mostrar contrasena"
														onClick={() => setShowPassword((current) => !current)}
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</Grid>
								<Grid item size={{ xs: 12, md: 6 }}>
									<TextField
										fullWidth
										type={showPasswordConfirm ? "text" : "password"}
										label="Confirmar contrasena"
										value={credentialsPasswordConfirm}
										onChange={(event) => onCredentialsPasswordConfirmChange(event.target.value)}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton
														edge="end"
														aria-label="mostrar confirmacion de contrasena"
														onClick={() =>
															setShowPasswordConfirm((current) => !current)
														}
													>
														{showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</Grid>
							</>
						)}

						{credentialsDialogError && (
							<Grid item size={{ xs: 12 }}>
								<Alert severity="error">{credentialsDialogError}</Alert>
							</Grid>
						)}
					</Grid>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={credentialsSaving}>
					Cancelar
				</Button>
				<Button
					variant="outlined"
					startIcon={<WhatsAppIcon />}
					onClick={onSaveAndWhatsapp}
					disabled={credentialsSaving || !persona}
				>
					{credentialsSaving ? "Guardando..." : "Guardar y WhatsApp"}
				</Button>
				<Button
					variant="contained"
					onClick={onSave}
					disabled={credentialsSaving || !persona}
				>
					{credentialsSaving ? "Guardando..." : "Guardar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
